import { IModule } from 'modules/common/interfaces';

import ErrorBoundaryProvider from './contexts/ErrorBoundary';

const errorModule: IModule = {
  providers: [{ Provider: ErrorBoundaryProvider }],
};

export default errorModule;
